jQuery(document).ready(function() {
    /*
     Wow
     */
    new WOW().init();

});